import { forwardRef, ReactNode, useImperativeHandle, useRef } from "react";

interface IProps {
    isOpen: boolean,
    setIsOpen: (isOpen: boolean) => void,
    title: string,
    handleAnimationEnd?: () => void,
    children: ReactNode,
    className?: string
}

export interface IPopupRef {
    isOpen: boolean,
    closePopup: () => void,
    togglePopup: () => void
}

const Popup = forwardRef<IPopupRef, IProps>(({ isOpen, setIsOpen, title, className, children }: IProps, ref) => {
    const popupRef = useRef<HTMLUListElement>(null);

    const closePopup = () => {
        if (isOpen && popupRef.current) {
            popupRef.current.setAttribute("close", "");
            setIsOpen(false);
        }
    }

    const handleAnimationEnd = () => {
        if (popupRef.current)
            popupRef.current.removeAttribute("close");
    }

    const togglePopup = () => {
        if (isOpen && popupRef.current) {
            popupRef.current.setAttribute("close", "");
        }
        setIsOpen(!isOpen);
    }

    useImperativeHandle(ref, () => ({
        isOpen,
        closePopup,
        togglePopup
    }));

    return <ul
        ref={popupRef}
        className={`popup absolute top-12 bg-white text-neutral-600 pb-2 rounded min-w-52 overflow-hidden transition-colors text-base ${className}`}
        data-open={isOpen ? isOpen : undefined}
        onAnimationEnd={handleAnimationEnd}
    >
        <li
            key={"title"}
            className={"bg-neutral-300 text-neutral-700 text-center py-2 font-medium px-2"}
        >
            {title}
        </li>
        {children}
    </ul>
}
)
export default Popup;